import React, { createContext, useContext } from 'react';
interface PricingContextType {
  price: string;
  priceValue: number;
  currency: string;
  currencySymbol: string;
  isEurope: boolean;
  isLoading: boolean;
}
const PricingContext = createContext<PricingContextType>({
  price: '£500',
  priceValue: 500,
  currency: 'GBP',
  currencySymbol: '£',
  isEurope: true,
  isLoading: false
});
export function PricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const value: PricingContextType = {
    price: '£500',
    priceValue: 500,
    currency: 'GBP',
    currencySymbol: '£',
    isEurope: true,
    isLoading: false
  };
  return <PricingContext.Provider value={value} data-id="element-355">{children}</PricingContext.Provider>;
}
export function usePricing() {
  return useContext(PricingContext);
}